// extracted by mini-css-extract-plugin
export default {"topRatedBadge":"GuideRatingInfo_topRatedBadge__8O57r","guideLink":"GuideRatingInfo_guideLink__tjTLL","guideLogo":"GuideRatingInfo_guideLogo__dyE6D"};